var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00DCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9001 2.8125C8.72325 2.8125 6.87431 4.4865 6.642 6.64144C4.48594 6.87431 2.8125 8.72325 2.8125 10.8996C2.8131 12.0365 3.26497 13.1267 4.06887 13.9307C4.87276 14.7347 5.96292 15.1868 7.09987 15.1875C9.27675 15.1875 11.133 13.5135 11.358 11.3586C13.5135 11.1257 15.1875 9.27675 15.1875 7.10044C15.1869 5.96349 14.735 4.87326 13.9311 4.06926C13.1272 3.26527 12.0371 2.81325 10.9001 2.8125ZM14.1829 7.58025C14.0758 8.28341 13.7468 8.93395 13.2439 9.43689C12.7409 9.93982 12.0904 10.2688 11.3872 10.3759V7.58025H14.1829ZM3.81712 10.4198C3.92274 9.71526 4.25111 9.06309 4.75417 8.55871C5.25722 8.05434 5.90854 7.72426 6.61275 7.61681V10.4124H3.81712V10.4198ZM10.3832 11.3872C10.267 12.1748 9.87142 12.8944 9.2686 13.4144C8.66577 13.9344 7.89599 14.2201 7.09987 14.2194C6.30391 14.2201 5.53427 13.9344 4.93155 13.4145C4.32883 12.8946 3.93326 12.1753 3.81712 11.3878H10.3832V11.3872ZM10.4198 7.58025V10.4124H7.58025V7.58025H10.4198ZM14.1829 6.61275H7.61681C7.73295 5.82515 8.12858 5.10563 8.7314 4.58563C9.33423 4.06564 10.104 3.77988 10.9001 3.78056C11.6961 3.77988 12.4657 4.06558 13.0685 4.58547C13.6712 5.10536 14.0667 5.8253 14.1829 6.61275Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGusd);
export default __webpack_public_path__ + "static/media/gusd.e0ee61ba6b47b66cdb0bb5e316ccb714.svg";
export { ForwardRef as ReactComponent };